import { Button, Dialog, DialogContent, Typography } from '@mui/material';
import React from 'react';

import { DialogChromeFooter, DialogChromeHeader } from 'components/atoms/Dialog/DialogChrome';
import Loader from 'components/Loader';

export const isWorkflowExportResolvingMessage = (message: string) =>
  /^(Finding the final cell tables|Resolving cell tables|Loading panel information|Loading feature names|Checking|Preparing)/.test(
    message
  );

interface WorkflowDirectExportStatusProps {
  title: string;
  message: string;
  onClose: () => void;
  resolving?: boolean;
  children?: React.ReactNode;
}

// Shown while a no-configuration download is resolving, or when it cannot start. Not the version chooser.
export const WorkflowDirectExportStatus: React.FC<WorkflowDirectExportStatusProps> = ({
  title,
  message,
  onClose,
  resolving = false,
  children,
}) => (
  <Dialog open fullWidth maxWidth="sm" onClose={onClose} aria-labelledby="workflow-direct-export-status-title">
    <DialogChromeHeader
      titleId="workflow-direct-export-status-title"
      title={title}
      onClose={onClose}
      closeButtonAriaLabel="Close export"
    />
    <DialogContent dividers>
      {resolving ? (
        <Loader inline message={message} ariaLabel={title} />
      ) : (
        <Typography variant="body2" role="status">
          {message}
        </Typography>
      )}
      {children}
    </DialogContent>
    <DialogChromeFooter>
      <Button color="inherit" onClick={onClose}>
        Close
      </Button>
    </DialogChromeFooter>
  </Dialog>
);
